export enum OperatorsType {
    PRINCIPAL = '1001',
    ASSISTANT = '1002'
}